'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import LaravelFAQ from '@/components/faqs/laravel-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import ChooseLaravel from '@/components/technologies/choose-laravel';
import TechnologyFaq from '@/components/technologies/technology-faq';
import FlutterServies from '@/components/technologies/laravel-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Take your business to the next level with our end-to-end Laravel application development services. Our Laravel developers build feature-rich Laravel web apps for a strong online experience for your target audience."
                alt="Laravel Development"
                title="Laravel Development"
                width={1090}
                height={604}
                path={'laravel-development-hero'}
                bgPath={'hero-bg-grunge-orange'}
                color="orange"
                isOrange={true}
            >
                Laravel <div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Laravel" />
            <ChooseLaravel title="Choose Laravel Development To Create Secured Web Apps Rapidly"></ChooseLaravel>
            <FlutterServies />
            <HireProcess
                bg="bg-laravel"
                pageTitle="Hire Laravel App Developers To Enhance Your Business Efficiency"
                desc="Maximize the possibilities of the newest Laravel version. You can hire our Laravel developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Laravel Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Laravel Developers"
                desc="Select from different engagement models to hire Laravel Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Laravel App Development Projects" bg="bg-laravel">
                <LaravelFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
